import { Fragment } from "react"
import { useParams } from "react-router"
import { NavLink } from "react-router-dom"
import { ToastContainer } from "react-toastify"
import CorporateForm from "src/components/signup/CorporateForm"
import PersonalForm from "src/components/signup/PersonalForm"
import { Footer } from "../../../components/Footer"
import { Header } from "../../../components/Header"
import { Promo } from "../../../components/login/Promo"
import { RegisterType } from "../types"
import { RegisterTypeTab } from "./components/RegisterTypeTab"

export const RegisterPage = () => {
  const { register_type } = useParams<{ register_type: RegisterType }>()
  const isCorporate = register_type === RegisterType.Corporate
  return (
    <Fragment>
      <Header isDark={false} />
      <ToastContainer autoClose={7000} />
      <div className="body__steps register">
        <div className="container">
          <RegisterTypeTab type={register_type} />

          <div className="row">
            <div className="col-lg-12">
              <div className="steps__box">
                <div className="row no-gutters">
                  <div className="steps__part_big steps__part_big_bg">
                    <div className="steps__box_light">
                      <div className="row">
                        <div className="col-md-6">
                          <h3 className="steps__box_title">Register </h3>
                        </div>
                        <div className="col-md-6">
                          <h3 className="steps__box_title text-lg-right text-left">
                            <span className="title__light">Already registered? </span>
                            <NavLink to="/login" className="title__link">
                              Login
                            </NavLink>
                          </h3>
                        </div>
                      </div>
                      {isCorporate ? <CorporateForm /> : <PersonalForm />}
                    </div>
                  </div>
                  <Promo />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer isDark={false} />
    </Fragment>
  )
}
